const LayoutMenu = (() => {

    class Core {

        constructor() {

            this.$menuUser = document.querySelector('.menu-user') || false,
            this.$hamburgerBlock = document.querySelector('.hamburger-block') || false;
        

            this.build_menu_user();

        }


        build_menu_user() {

            if (this.$hamburgerBlock !== false && this.$menuUser !== false) {

                if (window.innerWidth <= 980) this.$hamburgerBlock.insertAdjacentElement('beforebegin', this.$menuUser);

            }

        }

    }


    let active = null;


    const init = () => {

        active = new Core();
        return active;

    };


    return { init };

})();


window.LayoutMenu = LayoutMenu;


export { LayoutMenu }